export const engagementV2LinkTemplates = "/engagement/v2/link_templates";
